import React, { useEffect, useRef, useState } from 'react';

const colors = [
  '#F44336',
  '#E91E63',
  '#9C27B0',
  '#3F51B5',
  '#03A9F4',
  '#009688',
  '#4CAF50',
  '#FF9800',
  '#795548',
];

function getAvatarName(fullName) {
  if (!fullName) return '';
  const words = fullName.trim().split(/\s+/);
  const first = words[0]?.[0] || '';
  const last = words[words.length - 1]?.[0] || '';
  return (first + last).toUpperCase();
}

function getRandomColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index];
}

const Avatar = ({ fullName, size }) => {
  const avatarText = getAvatarName(fullName);
  const bgColor = getRandomColor(fullName);

  const avatarRef = useRef(null);
  const [fontSize, setFontSize] = useState(20);

  useEffect(() => {
    if (avatarRef.current) {
      const height = avatarRef.current.offsetHeight;
      setFontSize(height / 2);
    }
  }, []);
  return (
    <div
      style={{
        width: '100%',
        aspectRatio: 1,
        borderRadius: '50%',
        backgroundColor: bgColor,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        fontSize: fontSize,
      }}
    >
      {avatarText}
    </div>
  );
};

export default Avatar;
